import { ActionType } from 'deox';
import { takeLatest, put } from 'redux-saga/effects';

import { API } from 'api';

import { processRequestError } from 'modules/errors';

import { getCompanies } from './actions';

function* getCompaniesSaga({ payload }: ActionType<typeof getCompanies.request>) {
  try {
    const { data } = yield API.getCompanies(payload);
    yield put(getCompanies.success(data));
  } catch (error) {
    yield put(processRequestError({ error, failAction: getCompanies.fail }));
  }
}

export function* watchCompanies() {
  yield takeLatest(getCompanies.request, getCompaniesSaga);
}
